import { siArchiveConstants } from '../../_constants';

export function siArchive(state = {}, action) {
    switch (action.type) {
        case siArchiveConstants.RESET:
            return {}
        case siArchiveConstants.SI_ARCHIVE_FETCHING:
            return {
                ...state,
                siArchiveFetching: true
            };
        case siArchiveConstants.SI_ARCHIVE_FETCHED:
            return {
                ...state,
                siArchiveFetching: false
            };
        case siArchiveConstants.GET_POSTED_WB_PER_YEAR: {
            return {
                ...state,
                PostedWBPerYear: action.PostedWBPerYear
            }
        }
        case siArchiveConstants.GET_POSTED_WB_PER_MONTH: {
            return {
                ...state,
                PostedWBPerMonth: action.PostedWBPerMonth
            }
        }
        case siArchiveConstants.GET_POSTED_WB_PER_VESSEL: {
            return {
                ...state,
                PostedWBPerVessel: action.PostedWBPerVessel
            }
        }
        case siArchiveConstants.GET_POSTED_WB_PER_VOYAGE: {
            return {
                ...state,
                PostedWBPerVoyage: action.PostedWBPerVoyage
            }
        }
        case siArchiveConstants.GET_POSTED_WAYBILL: {
            return {
                ...state,
                PostedWaybill: action.PostedWaybill
            }
        }
        default:
            return state;
    }
}